//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            loading: false, // 加载状态
            finished: true, // 加载结束
            refreshing: false, // 下拉状态
            pageParams: {
                pageNum: 0,
                pageSize: 10
            },
            playTabs: [
                {
                    title: '全部'
                },
                {
                    title: '景点',
                    id: '1554720058076'
                },
                {
                    title: '自驾游',
                    id: '1554720058018'
                },
                {
                    title: '寻访',
                    id: '1554720058096'
                },
                {
                    title: '徒步',
                    id: '1554720058072'
                },
                {
                    title: '目的地',
                    id: '1554720058077'
                },
                {
                    title: '摄影',
                    id: '1554720058071'
                },
                {
                    title: '热门',
                    id: '1554720058145'
                },
                {
                    title: '乡村游',
                    id: '1554720058023'
                },
                {
                    title: '特色街区',
                    id: '1554720058217'
                },
                {
                    title: '精选',
                    id: '1554720058146'
                }
            ],
            notesLists: [],
            tabIndex: 0
        };
    },
    created() {
        this.getList();
        sessionStorage.clear();
    },
    methods: {
        edit(item){
            this.$router.push({
                name: 'changeStrategyContent',
                query: {
                    id: item.id
                }
            });
        },

        jumpPage(item) {
            this.$router.push({
                path: `/strDesViewNew`,
                query: {
                    id: item.id,
                    type: 'own'
                }
            });
        },

        toPage() {
            this.$router.push({
                path: '/strategy-content',
            });
        },

        getGlLsit(username, token) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(`/api/wtcp-traveltips/tipSelf/selfList?username=${username}&access_token=${token}`, {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                        }
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async getList() {
            const self = this;
            try {
                // 请求
                let result = await self.getGlLsit(JSON.parse(localStorage.getItem('userInfo')).user.username, JSON.parse(localStorage.getItem('userInfo')).access_token);
                if (result.data) {
                    const data = result.data;
                    self.notesLists = self.notesLists.concat(data);
                    self.loading = false;
                    if (data.length < 10) {
                        self.finished = true;
                    } else {
                        self.pageParams.pageNum++;
                        self.finished = false;
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        getTabIndex(index) {
            if (index === this.tabIndex) return;
            this.notesLists = [];
            this.pageParams.pageNum = 0;
            this.tabIndex = index;
            this.getList();
        },
        // 上拉加载
        onLoad() {
            this.getList();
        },
        // 下拉刷新
        onRefresh() {
            this.finished = false;
            this.loading = true;
            this.reset();
            this.getList();
            this.refreshing = false;
        },
        // 重置
        reset() {
            this.notesLists = [];
            this.pageParams.pageNum = 0;
        }
    }
};
